export default __webpack_public_path__ + "static/media/instagram-icon.e35a917d.svg";